import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { AuthHttp } from 'angular2-jwt';


@Injectable()
export class GroupService {
  // private http: Http, 
  constructor(private authHttp: AuthHttp) { }

  getGroupNames(all: boolean){
      return this.authHttp.get('/api/groupnames/'+all).map(res => res.json());
  }

  getGroups(){
    return this.authHttp.get("/api/groups").map(res => res.json());
  }
  
  getGroup(id: number){
    return this.authHttp.get('/api/groups/'+id).map(res => res.json());
  }

  update(group: any){
    // console.log("group: "+group)
    return this.authHttp.put('/api/groups/'+group.id,group).map(res => res.json());
  }

  create(group: any){
    // console.log("Post group: "+group)
    return this.authHttp.post('/api/groups',group).map(res => res.json());
  }

  changeGroupHidden(id: number){
    return this.authHttp.put('/api/groups/changeVisible/'+id,null).map( (res:any) => {
      return { 'status': res.status, 'value': res.json() }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/group.service.ts